import RefChip from './RefChip';

import { agentUrlTransform, parseRef } from '@/app/agentConversation/_helpers';

import { ChatMarkdown } from '@/app/ui/chat-markdown';

// Images are dropped: a reply is text, and an image URL the model wrote would
// be fetched by the browser the moment the reply renders.
const DISALLOWED_ELEMENTS = ['img'];

// A record link (zebel://<kind>/<uid>) becomes a chip that opens the record in
// the app; a safe web link opens in a new tab. `agentUrlTransform` has already
// blanked anything else, which renders as its text alone.
const AgentLink = ({ href, children }) => {
  const refValue = parseRef(href);
  if (refValue) {
    return <RefChip refValue={refValue}>{children}</RefChip>;
  }
  if (!href) return <>{children}</>;
  return (
    <a href={href} target="_blank" rel="noreferrer noopener" className="text-primary underline-offset-4 hover:underline">
      {children}
    </a>
  );
};

const Unwrapped = ({ children }) => <>{children}</>;

const blockComponents = { a: AgentLink };

// For a table cell: the same, without the paragraph around it.
const inlineComponents = { ...blockComponents, p: Unwrapped };

/**
 * The assistant's Markdown: GitHub-flavoured, no images, and only record links
 * (as chips, labelled from AgentRefsContext) and safe links kept.
 */
const MarkdownText = ({ markdown, inline = false }) => {
  return <ChatMarkdown markdown={markdown} components={inline ? inlineComponents : blockComponents} disallowedElements={DISALLOWED_ELEMENTS} urlTransform={agentUrlTransform} />;
};

export default MarkdownText;
